import { createAction } from "@reduxjs/toolkit";
import type { IViewportDimensions } from "./landing-action-creators";

export namespace ILandingActions {
  export enum Type {
    SET_VIEWPORT_DIMENSIONS = "SET_VIEWPORT_DIMENSIONS",

    // GET__IMAGE_BY_HASH__INIT = 'GET__IMAGE_BY_HASH__INIT',
    // GET__IMAGE_BY_HASH__SUCCESS = 'GET__IMAGE_BY_HASH__SUCCESS',
    // GET__IMAGE_BY_HASH__FAILURE = 'GET__IMAGE_BY_HASH__FAILURE',

    // IMAGE_DELETED carries the one cross-store side effect deleting an
    // image has beyond its own request status: account-reducer.ts
    // filtering the deleted photo out of user.featured.
    IMAGE_DELETED = "IMAGE_DELETED",

    POST__IMAGE_THROUGH__INIT = "POST__IMAGE_THROUGH__INIT",
    POST__IMAGE_THROUGH__SUCCESS = "POST__IMAGE_THROUGH__SUCCESS",
    POST__IMAGE_THROUGH__FAILURE = "POST__IMAGE_THROUGH__FAILURE",
    POST__IMAGE_THROUGH__RESET = "POST__IMAGE_THROUGH__RESET",

    SET__UPLOADER_PROCESSING = "SET__UPLOADER_PROCESSING",
    REMOVE__UPLOADER_PROCESSING = "REMOVE__UPLOADER_PROCESSING",
  }

  // export const initGetImageByHash = createAction<any>(Type.GET__IMAGE_BY_HASH__INIT);
  // export const successGetImageByHash = createAction<any>(Type.GET__IMAGE_BY_HASH__SUCCESS);
  // export const failureGetImageByHash = createAction<any>(Type.GET__IMAGE_BY_HASH__FAILURE);

  // export const initPostImageThrough = createAction<any>(Type.POST__IMAGE_THROUGH__INIT);
  // export const successPostImageThrough = createAction<any>(Type.POST__IMAGE_THROUGH__SUCCESS);
  // export const failurePostImageThrough = createAction<any>(Type.POST__IMAGE_THROUGH__FAILURE);
  // export const resetPostImageThrough = createAction<any>(Type.POST__IMAGE_THROUGH__RESET);

  export const imageDeleted = createAction<{
    public_id?: string;
    media_id?: string;
  }>(Type.IMAGE_DELETED);

  export const setViewportDimensions = createAction<IViewportDimensions>(
    Type.SET_VIEWPORT_DIMENSIONS
  );

  export const setUploaderProcessing = createAction<{ uploaderId: string }>(
    Type.SET__UPLOADER_PROCESSING
  );
  export const removeUploaderProcessing = createAction<{
    uploaderId: string;
  }>(Type.REMOVE__UPLOADER_PROCESSING);
}

export type LandingActions = Omit<typeof ILandingActions, "Type">;
